import { SearchFilters } from '../query-variables';

export const buildSkipConditions = (filters: SearchFilters, fixedTypes: string[]) => {
  const types = filters.contentTypes || [];

  const shouldSkipAllQueries = !filters.searchTerm && !types.length;

  return {
    queries: shouldSkipAllQueries,
    courses: types.length > 0 && !types.includes('Courses'),
    podcasts: types.length > 0 && !types.includes('Podcasts'),
    resources: types.length > 0 && !types.includes('Resources'),
    knowledgebases: types.length > 0 && types.every((type) => fixedTypes.includes(type)),
  };
};
